<div class="settings-page">
  <h1>Settings</h1>

  <div class="settings-tabs" role="tablist" aria-label="Settings">
    <button
      *ngIf="isAdmin"
      type="button"
      role="tab"
      class="settings-tab"
      [class.active]="activeTab === 'permissions'"
      [attr.aria-selected]="activeTab === 'permissions'"
      (click)="setTab('permissions')">
      Permissions
    </button>
    <button
      type="button"
      role="tab"
      class="settings-tab"
      [class.active]="activeTab === 'cameras'"
      [attr.aria-selected]="activeTab === 'cameras'"
      (click)="setTab('cameras')">
      Cameras
    </button>
  </div>

  <div class="settings-tab-panel" *ngIf="activeTab === 'permissions' && isAdmin">
    <app-manage-permissions></app-manage-permissions>
  </div>

  <div class="settings-tab-panel" *ngIf="activeTab === 'cameras'">
    <app-settings></app-settings>
  </div>
</div>
